import React from "react";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import MoreInfo from "../../CreateStudyPage/MaterialComponents/MoreInfo";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const PREFIX = "ImportantInfo";

const classes = {
  evaluationTextPositive: `${PREFIX}-evaluationTextPositive`,
  evaluationTextNegative: `${PREFIX}-evaluationTextNegative`,
};

const StyledGrid = styled(Grid)({
  [`& .${classes.evaluationTextPositive}`]: {
    color: "#4caf50",
    backgroundColor: "rgba(76, 175, 80, 0.08)",
    padding: "1px 2px",
    marginLeft: "8px",
  },
  [`& .${classes.evaluationTextNegative}`]: {
    color: "rgb(244, 67, 54)",
    backgroundColor: "rgba(244, 67, 54, 0.1)",
    padding: "1px 2px",
    marginLeft: "8px",
  },
});

//props: title,figure,evaluation, moreInfo, popupArray
export default function ImportantInfo(props) {
  return (
    <StyledGrid container>
      <Grid
        alignContent="flex-end"
        container
        wrap="nowrap"
        justifyContent="space-between"
        item
        xs={12}
      >
        <Typography variant="h6" component={"span"}>
          {props.title}
        </Typography>
        {props.popupArray ? (
          <MoreInfo
            outerContainerClassName="cacheSetup"
            popupArray={props.popupArray}
          />
        ) : (
          <MoreInfo
            outerContainerClassName="cacheSetup"
            popup={props.moreInfo}
          />
        )}
      </Grid>
      <Grid item container alignItems="center">
        <Typography component={"span"} display="inline" variant="h4">
          {props.figure}
        </Typography>
        {props.evaluation ? (
          <Typography
            component={"span"}
            variant="caption"
            className={
              props.color === "green"
                ? classes.evaluationTextPositive
                : classes.evaluationTextNegative
            }
            display="inline"
          >
            {props.color === "green" ? (
              <ArrowUpwardIcon
                style={{ fontSize: 14, verticalAlign: "middle" }}
              />
            ) : (
              <ArrowDownwardIcon
                style={{ fontSize: 14, verticalAlign: "middle" }}
              />
            )}{" "}
            {props.evaluation}
          </Typography>
        ) : (
          ""
        )}
      </Grid>
    </StyledGrid>
  );
}
